import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Loader2, Sparkles } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { processOAuthCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const userData = await processOAuthCallback(sessionId);
          toast.success('Welcome back!');
          
          // Redirect based on user role
          // Bookees/Talents go to Dashboard, Bookers (clients only) go to Home
          const isBookee = userData?.roles?.includes('bookee') || 
                           userData?.user_type === 'talent' || 
                           userData?.user_type === 'both';
          if (isBookee) {
            navigate('/dashboard', { replace: true });
          } else {
            navigate('/', { replace: true });
          }
        } catch (error) {
          console.error('OAuth callback error:', error);
          toast.error('Authentication failed. Please try again.');
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, processOAuthCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center hero-bg">
      <div className="hero-glow absolute inset-0" />
      <div className="text-center relative z-10">
        <Sparkles className="h-12 w-12 text-primary mx-auto mb-4 animate-pulse" />
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
        <p className="mt-4 text-muted-foreground">Completing sign in to Bookd...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
